module.exports = __webpack_public_path__ + "img/AT0000002650479.91b77d98.png";